import React from 'react';

const LoadingScreen = ({ fading = false }) => {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(160deg, #020c1a 0%, #041428 40%, #020c1a 100%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#fff',
        fontFamily: 'Arial, sans-serif',
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        overflow: 'hidden',
        opacity: fading ? 0 : 1,
        transform: fading ? 'scale(1.04)' : 'scale(1)',
        transition: 'opacity 0.65s ease, transform 0.65s ease',
        pointerEvents: fading ? 'none' : 'all',
      }}
    >
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        inset: 0,
        opacity: 0.05,
        backgroundImage: `
          linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px),
          linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)
        `,
        backgroundSize: '40px 40px'
      }}></div>

      {/* Floating particles */}
      <div style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        pointerEvents: 'none'
      }}>
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            style={{
              position: 'absolute',
              width: '4px',
              height: '4px',
              background: 'linear-gradient(135deg, #10b981, #06b6d4)',
              borderRadius: '50%',
              left: `${20 + i * 15}%`,
              top: `${30 + (i % 3) * 20}%`,
              animation: `float ${3 + i * 0.5}s ease-in-out infinite`,
              animationDelay: `${i * 0.5}s`,
              opacity: 0.6
            }}
          />
        ))}
      </div>

      <div
        style={{
          textAlign: 'center',
          position: 'relative',
          zIndex: 10
        }}
      >
        {/* Fish icon animation */}
        <div style={{
          fontSize: '4rem',
          marginBottom: '24px',
          animation: 'bounce 2s ease-in-out infinite'
        }}>
          🐠
        </div>

        {/* Loading text */}
        <div
          style={{
            fontSize: 'clamp(1.5rem, 4vw, 2rem)',
            fontWeight: 'bold',
            marginBottom: '32px',
            background: 'linear-gradient(135deg, #10b981, #06b6d4, #3b82f6)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            animation: 'pulse 2s ease-in-out infinite'
          }}
        >
          جاري التحميل...
        </div>

        {/* Enhanced spinner */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '24px'
          }}
        >
          <div style={{ position: 'relative' }}>
            {/* Outer ring */}
            <div
              style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                border: '4px solid rgba(16, 185, 129, 0.2)',
                borderTop: '4px solid #10b981',
                animation: 'spin 1s linear infinite',
                position: 'absolute'
              }}
            />
            {/* Inner ring */}
            <div
              style={{
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                border: '3px solid rgba(6, 182, 212, 0.3)',
                borderBottom: '3px solid #06b6d4',
                animation: 'spin 1.5s linear infinite reverse',
                margin: '10px',
                position: 'relative'
              }}
            />
            {/* Center dot */}
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '8px',
                height: '8px',
                background: 'linear-gradient(135deg, #10b981, #06b6d4)',
                borderRadius: '50%',
                animation: 'pulse 1s ease-in-out infinite'
              }}
            />
          </div>
        </div>

        {/* Loading dots */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '8px',
          marginBottom: '16px'
        }}>
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              style={{
                width: '8px',
                height: '8px',
                background: 'linear-gradient(135deg, #10b981, #06b6d4)',
                borderRadius: '50%',
                animation: `loadingDots 1.4s ease-in-out infinite`,
                animationDelay: `${i * 0.2}s`
              }}
            />
          ))}
        </div>

        {/* Subtitle */}
        <p style={{
          color: '#94a3b8',
          fontSize: '1rem',
          margin: '0',
          opacity: 0.8

        }}>
          يرجى الانتظار بينما نحضر لك أفضل تجربة 🌊
        </p>
      </div>

      {/* CSS for animations */}
      <style>
        {`
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }

          @keyframes pulse {
            0%, 100% {
              opacity: 1;
              transform: scale(1);
            }
            50% {
              opacity: 0.7;
              transform: scale(1.05);
            }
          }

          @keyframes bounce {
            0%, 100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-10px);
            }
          }

          @keyframes float {
            0%, 100% {
              transform: translateY(0px) rotate(0deg);
              opacity: 0.6;
            }
            50% {
              transform: translateY(-20px) rotate(180deg);
              opacity: 1;
            }
          }

          @keyframes loadingDots {
            0%, 80%, 100% {
              transform: scale(0.8);
              opacity: 0.5;
            }
            40% {
              transform: scale(1.2);
              opacity: 1;
            }
          }

          @media (max-width: 640px) {
            .loading-container {
              padding: 20px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default LoadingScreen;